/* eslint-disable react/prop-types */
import React from 'react';
import { Typography,  } from 'antd';

import styles from './InfoGrid.less';

const { Text } = Typography;

/**
 * InfoGrid —— 信息栅格
 * ------------------------------------------------------------------
 * 用来替换后台里大量「Descriptions bordered」表格（商品定价、GMV 汇总、
 * 支付宝签约信息、基础信息等）。本模块的信息展示不靠表格线，而是
 * 「浅灰标签 + 深色值」的栅格 + 分隔线，所以这里自绘一层。
 *
 * @param column  每行列数，默认 4
 * @param layout  'vertical'(标签在上) | 'horizontal'(标签在左)，默认 vertical
 * @param bordered 是否带外框与分隔线，默认 false
 * @param data    [{ label, value, key, span, render }]
 *                value 可以是任意 ReactNode；span 用于跨列
 */
const InfoGrid = (props) => {
  const {
    column = 4,
    layout = 'vertical',
    bordered = false,
    data = [],
    className,
  } = props;

  if (!data.length) return null;

  return (
    <div
      className={`${styles.grid} ${bordered ? styles.bordered : ''} ${
        layout === 'horizontal' ? styles.horizontal : ''
      } ${className || ''}`}
      style={{ gridTemplateColumns: `repeat(${column}, minmax(0, 1fr))` }}
    >
      {data.map((item, index) => (
        <div
          key={item.key || `${item.label}-${index}`}
          className={styles.item}
          style={{ gridColumn: `span ${item.span || 1}` }}
        >
          <div className={styles.label}>
            {item.label}
            {item.labelSuffix}
          </div>
          <div className={styles.value}>
            {item.value === undefined ||
            item.value === null ||
            item.value === '' ? (
              <Text className={styles.empty}>-</Text>
            ) : (
              item.value
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default InfoGrid;
